var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "multi-step-form new-login-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": "out-in"
    }
  }, [_c('div', {
    key: _vm.currentStep
  }, [_vm.currentStep === 1 ? _c('div', {
    staticClass: "step step-1 active"
  }, [_c('div', {}, [_c('div', {
    staticClass: "left-login"
  }, [_c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard-rep.svg"),
      "alt": "image-fluid"
    }
  })]), _c('div', {}, [_c('router-link', {
    attrs: {
      "to": "/smart-login"
    }
  }, [_c('button', {
    staticClass: "qr-login-btn"
  }, [_c('img', {
    staticClass: "me-2",
    attrs: {
      "src": require("../../assets/images/qr-icon.svg"),
      "alt": "qr icon"
    }
  }), _vm._v("Login with QR ")])])], 1)]), _c('h4', {
    staticClass: "login-title mb-2"
  }, [_vm._v("Login to Continue")]), _c('div', {
    staticClass: "auth-form pt-1 pb-3"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          on: {
            "submit": function submit($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return handleSubmit(_vm.checkEmailLogin);
            }
          }
        }, [_c('custom-input-text', {
          attrs: {
            "rules": {
              required: true,
              email: true
            },
            "customMessages": "Please enter your email address.",
            "customEmailMessage": "Please enter a valid email address",
            "labelFor": "Email",
            "labelName": "Email",
            "inputName": "Email",
            "formGroupClass": "form-group mb-1",
            "placeholder": "Please enter your email",
            "isErrorFlagSet": _vm.emailErrorFlag,
            "vmodel": _vm.form.username
          },
          on: {
            "emitChanges": _vm.resetErrorMsg,
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "username", $event);
            }
          }
        }), _vm.emailErrorFlag ? _c('div', {
          staticClass: "valid-error"
        }, [_vm._v(" " + _vm._s(_vm.errorMsg) + " ")]) : _vm._e(), _c('button', {
          staticClass: "submit-btn mt-3 next-btn",
          attrs: {
            "type": "submit",
            "disabled": _vm.loginLoader
          }
        }, [_vm.loginLoader ? _c('b-spinner', {
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" Next ")], 1)], 1)];
      }
    }], null, false, 2481333986)
  })], 1)])]) : _vm._e(), _vm.currentStep === 2 ? _c('div', {
    staticClass: "step step-2 active"
  }, [_c('div', {
    on: {
      "click": _vm.goBack
    }
  }, [_c('h6', {
    staticClass: "login-highlight"
  }, [_vm._v("Back")])]), _c('div', {}, [_c('div', {
    staticClass: "left-login"
  }, [_c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard-rep.svg"),
      "alt": "image-fluid"
    }
  })]), _c('div', {}, [_c('a', {
    attrs: {
      "href": "/smart-login"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/smart-login"
    }
  }, [_c('button', {
    staticClass: "qr-login-btn"
  }, [_c('img', {
    staticClass: "me-2",
    attrs: {
      "src": require("../../assets/images/qr-icon.svg"),
      "alt": "qr icon"
    }
  }), _vm._v("Login with QR ")])])], 1)])]), _c('h4', {
    staticClass: "login-title mb-0"
  }, [_vm._v("Login to Continue")]), _c('div', {
    staticClass: "auth-form pt-3 pb-3"
  }, [_c('div', {
    staticClass: "email-change-wrap"
  }, [_c('div', {}, [_vm._v(_vm._s(_vm.repEmail))]), _c('div', {
    staticClass: "login-highlight",
    on: {
      "click": function click($event) {
        _vm.currentStep = 1;
      }
    }
  }, [_vm._v("Change")])]), _c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var handleSubmit = _ref2.handleSubmit;
        return [_c('form', {
          on: {
            "submit": function submit($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return handleSubmit(_vm.handleLogin);
            }
          }
        }, [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v("Password"), _c('span', {
          staticClass: "required-label mt-2"
        }, [_vm._v("*")])]), _c('div', {
          staticClass: "login-password-container"
        }, [_c('custom-input-text', {
          attrs: {
            "rules": {
              required: true
            },
            "customMessages": "Please enter your password",
            "labelFor": "",
            "labelName": "Password",
            "placeholder": "Please enter your password",
            "inputType": _vm.passwordType,
            "formGroupClass": "form-group mb-1",
            "isErrorFlagSet": _vm.passwordErrorFlag,
            "vmodel": _vm.password
          },
          on: {
            "emitChanges": _vm.resetErrorMsg,
            "update:vmodel": function updateVmodel($event) {
              _vm.password = $event;
            }
          }
        }), _c('eye-button', {
          staticClass: "login-toggle-eye-icon",
          attrs: {
            "id": "password",
            "hideOnDefault": "false",
            "value": _vm.password,
            "type": "text"
          },
          on: {
            "toggle": _vm.togglePasswordVisibility
          }
        }), _vm.passwordErrorFlag ? _c('div', {
          staticClass: "valid-error"
        }, [_vm._v(" " + _vm._s(_vm.errorMsg) + " ")]) : _vm._e()], 1), _c('button', {
          staticClass: "submit-btn mt-3 next-btn",
          attrs: {
            "type": "submit"
          }
        }, [_vm.loginLoader ? _c('b-spinner', {
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" Login ")], 1)])];
      }
    }], null, false, 978072288)
  })], 1), _c('div', {
    staticClass: "left-login mb-0"
  }, [_c('div', {
    staticClass: "login-highlight",
    on: {
      "click": _vm.generateOTP
    }
  }), _c('router-link', {
    attrs: {
      "to": "/forgot-password"
    }
  }, [_c('div', {
    staticClass: "login-highlight"
  }, [_vm._v(" Forgot Password? ")])])], 1)])]) : _vm._e()])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }